import React, { useState } from "react";
import styles from "./index.module.scss";
import { _Select } from "../../FormSelect";
import LeftArrowIcon from "./left-arrow.svg";
import Link from "next/link";
import Content from "./Blocks/Content";
import Carousel from "./Blocks/Carousel";
import GetStarted from "../../../sections/GetStarted";
import CopyLinkButton from "components/UI/CopyLinkButton";

export default function DetailView(props) {
  const { data, fullImg, fullImgState } = props;
  const [version, setVersion] = useState({
    ...data.versions[0],
    value: data.versions[0].id,
    label: data.versions[0].name ? data.versions[0].name : "version unknown",
    editors_note: data.editors_note,
  });

  const platforms = (type) => {
    switch (type) {
      case "ios":
        return "iOS";
      case "android":
        return "Android";
      default:
        return "None";
    }
  };

  return (
    <div className="container">
      <div className={styles.root}>
        <div className={styles.box}>
          <div className={styles.sidebar}>
            <div className={styles.actions}>
              <Link href="/gallery">
                <a>
                  <span>
                    <LeftArrowIcon />
                    &nbsp; Back to Paywalls Library
                  </span>
                </a>
              </Link>
              <div className={`${styles.mobileView} ${styles.mobCopyLink}`}>
                <CopyLinkButton props={props} />
              </div>
            </div>
            <div className={`${styles.mobileView} ${styles.item}`}>
              <Content data={data} />
            </div>
            <div className={`${styles.mobileView} ${styles.item}`}>
              <Carousel
                fullImg={fullImg}
                fullImgState={fullImgState}
                data={[
                  {
                    src: version.video_url.thumb,
                    type: "video",
                    id: "video",
                    url: version.preview.thumb,
                  },
                  version?.paywalls_images,
                  version?.onboard_images,
                ]}
              />
            </div>
            <div className={styles.item}>
              <label>Category</label>
              <ul>
                {data.categories.map((cat, i) => (
                  <li key={i}>
                    <Link href={`/gallery?categories=${cat.id}`}>
                      <a>{cat.name}</a>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.item}>
              <label>Platform</label>
              <ul>
                <li>
                  <Link
                    // href={`/gallery?platform=${
                    //   data.platform === "ios" ? 1 : 0
                    // }`}
                    href="/gallery"
                  >
                    <a>{platforms(data.platform)}</a>
                  </Link>
                </li>
              </ul>
            </div>
            {data.call_to_actions.length > 0 && (
              <div className={styles.item}>
                <label>Call to action</label>
                <ul>
                  {data.call_to_actions.map((action, i) => (
                    <li key={i}>
                      <Link href={`/gallery?call_to_actions=${action.id}`}>
                        <a>{action.name}</a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className={styles.item}>
              <label>Version</label>
              <div className={styles.form}>
                {data.versions.length === 1 ? (
                  <p>
                    {data.versions[0].name
                      ? data.versions[0].name
                      : "version unknown"}
                  </p>
                ) : (
                  <_Select
                    placeholder="Select version"
                    name="version"
                    value={version}
                    onChange={(e) => setVersion(e)}
                    options={data.versions.map((v) => ({
                      ...v,
                      value: v.id,
                      label: v.name,
                    }))}
                  />
                )}
              </div>
            </div>
            {version?.editors_note && (
              <div className={styles.item}>
                <label>Editor's note</label>
                <p>{version?.editors_note}</p>
              </div>
            )}
          </div>
        </div>
        <div className={styles.content}>
          <CopyLinkButton props={props} />
          <Content
            data={data}
            version={version}
            fullImg={fullImg}
            fullImgState={fullImgState}
          />
        </div>
      </div>
      <div className={styles.section}>
        <GetStarted />
      </div>
    </div>
  );
}
